import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
/** A white surface on the page: sections of a detail page, a form's groups, a dashboard panel. */
export function Card({ className, ...props }) {
    return (_jsx("div", { className: cn("rounded-xl border border-border bg-card text-card-foreground shadow-card", className), ...props }));
}
/** Title row; `bordered` draws a line under it (a panel with a list inside). */
export function CardHeader({ className, bordered = false, ...props }) {
    return (_jsx("div", { className: cn("flex flex-col gap-1 p-5 sm:p-6", bordered && "border-b border-border pb-4 sm:pb-4 [&+*]:pt-4", className), ...props }));
}
export function CardTitle({ className, ...props }) {
    return _jsx("h2", { className: cn("text-base leading-tight font-semibold tracking-tight", className), ...props });
}
export function CardDescription({ className, ...props }) {
    return _jsx("p", { className: cn("text-sm text-muted-foreground", className), ...props });
}
/** Sits under a header, so no top padding; as a card's first child (no header) it keeps its own. */
export function CardContent({ className, ...props }) {
    return _jsx("div", { className: cn("p-5 pt-0 first:pt-5 sm:p-6 sm:pt-0 sm:first:pt-6", className), ...props });
}
export function CardFooter({ className, ...props }) {
    return (_jsx("div", { className: cn("flex items-center gap-2 border-t border-border px-5 py-4 sm:px-6", className), ...props }));
}
//# sourceMappingURL=card.js.map